import script from "./GlobalSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSearch.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalSearch.vue?vue&type=style&index=0&id=19475395&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19475395"]])

export default __exports__